module.exports = __webpack_public_path__ + "img/shoerackA05.67627f47.jpg";